import { useMutation } from '@tanstack/react-query';
import type { ChangePasswordRequest } from '@seo/types';
import { apiPost } from '@/lib/api';

/**
 * POST /v1/me/password — verifies the current password server-side, then
 * stores a new bcrypt hash. Returns 204 on success; bad-current-password
 * comes back as a UserError with code `AUTH_CURRENT_PASSWORD_WRONG`.
 */
export function useChangePassword() {
  return useMutation({
    mutationFn: (input: ChangePasswordRequest) =>
      apiPost<void>('/v1/me/password', input),
  });
}
